import { CONFIGS_REQUEST, CONFIGS_SHOW, CONFIG_EDIT, CONFIGS_FAIL, CONFIG_CLEAR, CONFIGS_LIST
} from '../store/config';

const configsDefault = {
    isFetching: false,
	list: {},
	edit: {
		phases_groups:[]
	},
	pages: {
		current: 0,
		per_page: 0,
		total: 0
	},
	permissions: [],
    error: undefined,
    timestamp: undefined
}

const configs= (state = configsDefault, action) => {
	switch(action.type) {
        case CONFIGS_REQUEST:{
            return {
                ...state,
                isFetching: action.isFetching,
                timestamp: action.timestamp
            }
        }
		case CONFIGS_SHOW:
			return {
				...state,
				isFetching: action.isFetching,
                list: action.payload,
				pages: action.pages,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case CONFIGS_LIST:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				timestamp: action.timestamp
			}
		case CONFIG_EDIT:
			return {
				...state,
				isFetching: action.isFetching,
				edit: {
					...state.edit,
					...action.payload
				},
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case CONFIG_CLEAR:
			return {
				...state,
				edit: action.payload,
				timestamp: action.timestamp
			}
		case CONFIGS_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
}

export default configs;



// WEBPACK FOOTER //
// ./src/reducers/configs.js